import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import TutorsList from "./TutorsList";

const TutorsListWrapper = () => {

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Control de acceso' },
        { name: 'Tutores', href: menuRoutes.tutors.path },
    ];
    
    const defaultFilters = {
        active: null,
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de tutores" breadcrumb={breadCrumb}>
                    {
                        userCan('create_tutors', 'tutors') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { navigate(menuRoutes.tutors.create) }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear tutor
                            </Button>
                        )
                    }

                </PageHeader>
                <TutorsList />
            </FiltersProvider>
        </Fragment>
    );
}

export default TutorsListWrapper;